// AMO+CO storefront currency converter (Shopify build)
// THB is always the primary displayed price (it's what checkout charges);
// for non-Thai visitors a smaller "~ £33.84" approximation is shown below it.
//
// window.__amo is populated by layout/theme.liquid from Shopify's
// `localization.country` Liquid object. Country selection itself is
// handled by Shopify's native country form in sections/header.liquid
// (page reloads on submit, updating localization.country).

(function () {
  'use strict';

  const FX_CACHE_MS = 24 * 60 * 60 * 1000;

  // Map ISO country code → display currency. We can't trust
  // `localization.country.currency.*` from Liquid: without Shopify
  // Markets (which needs Shopify Payments, unavailable in Thailand)
  // it always returns the store's base currency (THB), regardless of
  // the country Shopify routed us to.
  const COUNTRY_CURRENCY = {
    GB: { code: 'GBP', symbol: '£' },
    US: { code: 'USD', symbol: '$' },
    CA: { code: 'CAD', symbol: 'C$' },
    AU: { code: 'AUD', symbol: 'A$' },
    NZ: { code: 'NZD', symbol: 'NZ$' },
    JP: { code: 'JPY', symbol: '¥' },
    SG: { code: 'SGD', symbol: 'S$' },
    TH: { code: 'THB', symbol: '฿' },
    // Eurozone
    AT: { code: 'EUR', symbol: '€' }, BE: { code: 'EUR', symbol: '€' },
    CY: { code: 'EUR', symbol: '€' }, EE: { code: 'EUR', symbol: '€' },
    FI: { code: 'EUR', symbol: '€' }, FR: { code: 'EUR', symbol: '€' },
    DE: { code: 'EUR', symbol: '€' }, GR: { code: 'EUR', symbol: '€' },
    HR: { code: 'EUR', symbol: '€' }, IE: { code: 'EUR', symbol: '€' },
    IT: { code: 'EUR', symbol: '€' }, LV: { code: 'EUR', symbol: '€' },
    LT: { code: 'EUR', symbol: '€' }, LU: { code: 'EUR', symbol: '€' },
    MT: { code: 'EUR', symbol: '€' }, NL: { code: 'EUR', symbol: '€' },
    PT: { code: 'EUR', symbol: '€' }, SK: { code: 'EUR', symbol: '€' },
    SI: { code: 'EUR', symbol: '€' }, ES: { code: 'EUR', symbol: '€' },
    // Non-euro EU
    BG: { code: 'BGN', symbol: 'лв' }, CZ: { code: 'CZK', symbol: 'Kč' },
    DK: { code: 'DKK', symbol: 'kr' }, HU: { code: 'HUF', symbol: 'Ft' },
    PL: { code: 'PLN', symbol: 'zł' }, RO: { code: 'RON', symbol: 'lei' },
    SE: { code: 'SEK', symbol: 'kr' }
  };

  function resolveCurrency() {
    const cc = (window.__amo && window.__amo.countryCode) || 'GB';
    const mapped = COUNTRY_CURRENCY[cc] || { code: 'USD', symbol: '$' };
    return { countryCode: cc, currencyCode: mapped.code, currencySymbol: mapped.symbol };
  }

  async function getRate(targetCurrency) {
    if (targetCurrency === 'THB') return 1;
    const cacheKey = 'amo_fx_' + targetCurrency;
    let cached;
    try { cached = JSON.parse(localStorage.getItem(cacheKey)); } catch (e) {}
    if (cached && Date.now() - cached.ts < FX_CACHE_MS) return cached.rate;
    try {
      const r = await fetch('https://api.frankfurter.dev/v1/latest?base=THB&symbols=' + targetCurrency);
      if (!r.ok) throw new Error('fetch failed: HTTP ' + r.status);
      const d = await r.json();
      const rate = d.rates[targetCurrency];
      if (!rate) throw new Error('no rate for ' + targetCurrency);
      localStorage.setItem(cacheKey, JSON.stringify({ rate: rate, ts: Date.now() }));
      return rate;
    } catch (e) {
      console.warn('[amo currency] FX fetch failed — falling back to THB display', e);
      return null;
    }
  }

  function formatPrice(thb, currencyCode, currencySymbol, rate) {
    if (currencyCode === 'THB' || !rate) {
      return '฿' + thb.toLocaleString('en-US');
    }
    const local = thb * rate;
    const decimals = (currencyCode === 'JPY' || currencyCode === 'HUF') ? 0 : 2;
    return currencySymbol + local.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  async function applyCurrency() {
    const resolved = resolveCurrency();
    const cc = resolved.currencyCode;
    const sym = resolved.currencySymbol;
    // Keep window.__amo in sync so any other consumer reads the resolved values
    window.__amo = Object.assign({}, window.__amo, resolved, { baseCurrency: 'THB' });
    const rate = await getRate(cc);

    document.querySelectorAll('[data-thb-amount]').forEach(function (el) {
      const thb = parseFloat(el.dataset.thbAmount);
      if (isNaN(thb)) return;
      const suffix = el.dataset.thbSuffix || '';
      let html = '฿' + thb.toLocaleString('en-US') + (suffix
        ? ' <small style="font-size:0.4em;font-weight:400;opacity:0.7;vertical-align:middle">' + suffix + '</small>'
        : '');
      if (cc !== 'THB' && rate) {
        html += '<span class="approx-local">~&thinsp;' + formatPrice(thb, cc, sym, rate) + '</span>';
      }
      el.innerHTML = html;
    });

    document.querySelectorAll('.checkout-disclaimer').forEach(function (el) {
      el.style.display = (cc === 'THB') ? 'none' : '';
    });

    // Rewrite country dropdown labels to show the *correct* currency for each
    // country (Liquid renders them all as "(THB ฿)" without Shopify Markets).
    document.querySelectorAll('button[name="country_code"]').forEach(function (btn) {
      const iso = btn.value;
      const mapped = COUNTRY_CURRENCY[iso] || { code: 'USD', symbol: '$' };
      // Strip "(THB ฿)" or any " (XXX y)" suffix from the original label, then re-append.
      const baseName = btn.textContent.replace(/\s*\([^)]*\)\s*$/, '').trim();
      btn.textContent = baseName + ' (' + mapped.code + ' ' + mapped.symbol + ')';
    });

    // Header / mobile trigger labels (shows currently selected country + currency).
    document.querySelectorAll('#country-btn, .header__country-btn, #mobile-country-trigger, .mobile-nav__country-btn').forEach(function (trigger) {
      const svg = trigger.querySelector('svg');
      trigger.textContent = ' ' + resolved.countryCode + ' (' + cc + ' ' + sym + ') ';
      if (svg) trigger.appendChild(svg);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCurrency);
  } else {
    applyCurrency();
  }

  // Public API for any template that rebuilds prices dynamically (e.g. variant changes)
  window.amoCurrency = { applyCurrency: applyCurrency, getRate: getRate, formatPrice: formatPrice };
})();
